import { RefObject } from 'react';

export const scrollToRefWithOffset: (ref: RefObject<HTMLDivElement>, offset: number) => void
= (ref: RefObject<HTMLDivElement>, offset: number): void => {
  if (!ref.current) {
    return;
  }

  const rect: DOMRect = ref.current.getBoundingClientRect();
  const absoluteTop: number = window.scrollY + rect.top;

  window.scrollTo({ top: absoluteTop - offset, behavior: 'smooth' });
};
